import React from "react";
import ProfileHeader from "../Headers/ProfileHeader";
import HeaderUnauthenticated from "../Headers/HeaderUnauthenticated";
import {Accordion, Card} from "react-bootstrap";

function QuestionAnswer(props: { isCognitoUser: boolean, cognitoUser: any }) {
  const {isCognitoUser, cognitoUser} = props;
  const title = "Questions & Answers";
  const header = isCognitoUser ? <ProfileHeader cognitoUser={cognitoUser} title={title} linkToHome="/home"/>
    : <HeaderUnauthenticated title={title}/>

  return (
    <>
      {header}
      <section className="container question_answer p-4 rounded profile-wizard">
        <Accordion defaultActiveKey="0">
          <Card>
            <Accordion.Toggle as={Card.Header} eventKey="0">
              How do I add an Admin, Member to my Org , or a Guest to a Villa using the email they used to sign up to
              Villa?
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="0">
              <Card.Body>
                <p>
                  Invite users to your Org or Villa respectively as shown below.
                </p>
                <img alt="Add member or admin"
                     width="100%"
                     src="https://prod-copiedassetsbucket30a4c182-1rfirqh4svxz.s3.amazonaws.com/qa/add_member_Screen%2BRecording%2B2021-06-10%2Bat%2B12.24.25%2BAM.gif"/>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Accordion.Toggle as={Card.Header} eventKey="1">
              How do I link my device to my account?
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="1">
              <Card.Body>
                <img alt="Link device"
                     width="100%"
                     src="https://prod-copiedassetsbucket30a4c182-1rfirqh4svxz.s3.amazonaws.com/qa/link_device_to_account_Screen%2BRecording%2B2021-06-10%2Bat%2B12.33.22%2BAM.gif"/>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Accordion.Toggle as={Card.Header} eventKey="2">
              How do I connect my free or paid Sketchfab account so I can view collections, upload, purchase, and
              subscribe to lists of models, then spawn them in Villa?
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="2">
              <Card.Body>
                <p>
                  Please open a free account on <a href="https://sketchfab.com/">https://sketchfab.com/</a> and then
                  link your account as shown below.
                </p>
                <img alt="Connect SketchFab"
                     width="100%"
                     src="https://prod-copiedassetsbucket30a4c182-1rfirqh4svxz.s3.amazonaws.com/qa/connect_sketchfab_Screen%2BRecording%2B2021-06-10%2Bat%2B12.36.38%2BAM.gif"/>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Accordion.Toggle as={Card.Header} eventKey="3">
              Villa AI Conversation and Customizing AI
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="3">
              <Card.Body>
                <p>
                  Now Villa users can design their own AI Conversations to drive visitor interactions in your worlds
                  with AI! Here's how:
                </p>
                <p>
                  a. To activate, you must open a free web Villa account (unless you have one already) on
                  app.villa.rocks. If you came in as Accountless, simply go back in Villa in VR to
                  Settings &gt; Advanced &gt; Logout. This will bring you back to the Welcome screen. Now look carefully
                  to the right panel for instructions. It's very simple. You'll open your account on any browser, and
                  input the 5 digit blinking code. This gives you many more features, and has $0 cost, other than
                  spending 5 minutes to create the account.
                </p>
                <p>
                  b. Once logged in, head to Hamburger (the 3 horizontal lines at top right or left of the
                  screen) &gt; Conversations. From there start and name a new Conversation by adding prompt after prompt
                  of what you want the AI to say. When done head to Villa to your Villa of choice in your organization
                  (not sure? simply look at dropdown top right of Menu, or click on My Villas). Remember in your org you
                  can have up to 10 Villas, each with different geos including DIY.
                </p>
                <p>
                  c. Bring up the Spawn menu in any Villa by pressing and holding the A button &gt; release on
                  Spawn &gt; AI Assistant and look to the 3rd tab, the right most, called Conversations. Choose the
                  Conversation you named and the next time visitors including you come to the Villa, they'll be greeted
                  by this AI Conversation you just built.
                </p>

                <p>Some ideas for how this can be used:</p>

                <p>
                  * When you build a custom virtual world - how would you like to greet your visitors? What would you
                  like
                  them to know or learn?</p>
                <p>
                  * If you're at a company and use this for work - what would you like to inform your users or visitors?
                </p>
                <p>
                  * If you're a professor, what would you like your students to know? Use this as a tutor or a teaching
                  tool</p>

                <p>Remember that if you have proprietary or specialized information - you can also use the "Customize
                  AI"
                  tab from your web account's Hamburger icon &gt; Customize AI. You can copy/paste or type in up to 16K
                  characters. This appends as instructions for your Org or your particular Villa. Your AI will be
                  weighted
                  heavily to answer against information that you paste there, so be sure to remove it in case you don't
                  need or like that customization any more.
                </p>

                <p>Please note: You can only create Conversations and customize AI in your own org and Villas.</p>

                <div style={{paddingBottom: "56.25%", position: "relative", display: "block", width: "100%"}}>
                  <iframe width="100%" height="100%" src="https://www.youtube.com/embed/f5jDDZjkwdg?si=PXeaj01xX73TNcFX"
                          title="YouTube video player" frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                          allowFullScreen
                          style={{position: "absolute", top: 0, left: 0}}
                  ></iframe>
                </div>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Accordion.Toggle as={Card.Header} eventKey="4">
              How do I upload 2D and 3D objects to Villa?
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="4">
              <Card.Body>
                <p>
                  The following formats are accepted: JPEG, PNG for pics and screenshots, and GLTF, GLB, OBJ, or FBX
                  for 3D, both zipped or unzipped.
                </p>
                <p>
                  Note: For presentations or slide shows simply screenshot each slide on your PC, Mac, Smartphone or
                  Tablet, then drag/drop into your designated folder in <span
                  className="text-nowrap orange">top right menu &gt; Library</span>,
                  the top screenshot
                  will display first in VR so be sure to number each slide first then drag to arrange them in the right
                  order.
                </p>
                <img alt="Connect SketchFab"
                     width="100%"
                     src="https://prod-copiedassetsbucket30a4c182-1rfirqh4svxz.s3.amazonaws.com/qa/upload_pictures_Screen%2BRecording%2B2021-06-10%2Bat%2B12.41.10%2BAM.gif"/>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Accordion.Toggle as={Card.Header} eventKey="6">
              How do I cancel, upgrade, or change my subscription or plan?
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="6">
              <Card.Body>
                <p>
                  If you're a consumer using Meta Quest 2 and above, head to your mobile companion app or in VR go to <span
                  className="text-nowrap orange">profile &gt; settings &gt; subscriptions &gt; active subscriptions</span>.
                  To upgrade or change plans, first cancel the current plan, then come back and grab a new plan in VR
                  when the original one elapses. You can find more information here <a className="orange"
                                                                                       href="https://store.facebook.com/help/quest/articles/accounts/purchasing-apps/cancel-an-app-subscription"><span
                  className="text-nowrap orange">Canceling your Oculus Subscription</span></a>.
                </p>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Accordion.Toggle as={Card.Header} eventKey="7">
              How do I build my Metaverse on Villa?
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="7">
              <Card.Body>
                <p>
                  In your org, create a new Villa, choose which geo you'd like. To start from scratch, select DIY.
                  Search for 2D pictures, 3D models, and objects you'd like to include by pressing the <span
                  className="text-nowrap orange">A button &gt; Spawn!</span> or drag/drop any file you
                  find online into your Library on this account. Arrange them as you wish.
                </p>
                <p>
                  We recommend that you Google how to install OVR Metrics and run it in the background to help you
                  optimize and choose 2D and 3D objects that are not going to compromise your Metaverse's performance,
                  by monitoring that the FPS
                  stays above 60 at all times. You can set your device to accept 120 Hz from <span
                  className="text-nowrap orange">Oculus Settings &gt; Experimental</span>,
                  and that way you'll run at a higher refresh rate (highly recommended).
                </p>
                <p>
                  PS: Do you wish to exhibit publicly, or host a networking event? Do so in VR from Edit Villa using the
                  pencil icon and choose moderator settings.
                </p>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Accordion.Toggle as={Card.Header} eventKey="8">
              I'm an NFT fan! How do I use NFTs on Villa?
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="8">
              <Card.Body>
                <p>
                  Connect your wallet from <span
                  className="text-nowrap orange">top right menu &gt; App integrations</span>. You can also view other
                  peoples collections from there.
                  In the near future we'll enable users to buy and sell virtual real estate on Villa using NFTs, in
                  addition to the in-app fiat coin system which was launched end of June 2022.
                </p>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Accordion.Toggle as={Card.Header} eventKey="9">
              I'm not into NFTs, can I buy virtual land with a credit card?
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="9">
              <Card.Body>
                <p>
                  Yes buying virtual land on Villa with a credit card is now available on Villa in VR. From any Villa
                  press and hold the A or X button &gt; Menu &gt; click Galactica on the bottom tray.
                </p>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Accordion.Toggle as={Card.Header} eventKey="10">
              I have a large Enterprise and I need a secure Metaverse for my workforce and clients. What do I do?
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="10">
              <Card.Body>
                <p>
                  There are 1 and 3 year enterprise packages for your entire company. If you have &gt; 100 employees,
                  reach out
                  to <a href="mailto:info@villa.rocks" target="blank" rel="nopener"><span
                  className="orange">info@villa.rocks</span></a>
                  with your request and a member of the team will promptly respond to get you set up. If you're &lt; 100
                  employees,
                  it's probably easiest to have your employees obtain the subscription over the Quest Store, and
                  reimburse team members
                  individually, just be sure to point them at the annual plans for maximum savings.
                </p>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Accordion.Toggle as={Card.Header} eventKey="11">
              How do I install OVR Metrics on Meta Quest so I can monitor my Metaverse FPS and optimize for best
              performance?
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="11">
              <Card.Body>
                <p>
                  Building in 3D is a ton of fun, and doing it right is as much an art as a science. Please follow these
                  guidelines closely.
                  First off, remember that Villa runs on all-in-one mobile android devices which can be compute
                  constrained relative to powerful
                  PC based systems. Just like a model that 'weighs' many megabytes can take time to load and perform on
                  a website, all the more so
                  in 3D where you have a lot more compute to handle since it's not just x,y but also z. So in general:
                  pick models that are low
                  in polygons. Polygons are the building blocks of 3D models. Imagine pyramids as those building blocks.
                  File types for 3D such
                  as OBJ, FBX, GLTB, etc will often show how many polygons they have. The general guideline is 'less is
                  better'. However, these
                  polygons often represent levels of detail. The more detail, the more photorealistic. The less detail,
                  the more cartoonish a
                  model will look. Great 3D artists that know topology and optimization, will always attempt to maximize
                  detail and minimize the
                  number of polygons. A model can have 5K polygons and look photorealistic because it was optimized. And
                  another model of the same
                  type can be 500K polygons and look bad. Always be searching for models that are lower. In general, see
                  if you can find 5K-10K
                  models, but you're welcome to experiment going up higher to even 500K. Another metric is the texture,
                  measured in MB.
                  Look for tops 2K texture, less is best.
                </p>
                <p>
                  Try not to ever spawn more than a few models that have more than 10MB each. Best combos are &lt; 10K
                  polygons and &lt; 1MB
                  in texture per object. Also rather than concentrate a lot of polygons and MBs in one spot with many
                  objects, spread them out.
                </p>
                <p>
                  Total polygons/MB for the scene: up to 500K and 20MB across all the objects in your world? This is
                  where OVR Metrics becomes handy.
                  When you run it on your Quest 2 and above device, you'll see the metrics running in the background and then the
                  trick is to always keep the
                  FPS (frames per second) at &gt; 60 FPS. Don't forget to set your device settings under Experimental to
                  120 FPS. And if you can get away
                  with keeping your FPS around 90 everywhere, you did really well. With attention to detail and lots of
                  trial and error, you'll find
                  just the right combo for your worlds.
                </p>
                <p>
                  Notice that under Sketchfab you can filter for models that have animations. Not all user-generated
                  animations work, though most do.
                  Before you make a Villa or parcel of land public, test to make sure you don't crash.
                </p>
                <p>
                  We have checks and balances to help you eliminate a situation where your Metaverse crashes Quest 2
                  with a bad model. Here's what we did:
                  We wait 15 seconds for the spawned object to be there, before we auto-save it. If the object takes
                  more resources than the GPU/CPU of
                  your Meta Quest can process, your app will crash, usually within 15 seconds. If this happens, you'll
                  need to wait 5+ minutes before the cache
                  of the object disappear from that Villa. Simply don't come back to the same Villa if this happens.
                  Also you can make sure that the bad model
                  didn't save by heading on your web account to that villa's page, scrolling to the bottom, and looking
                  for 2D/3D Assets at the bottom. When
                  you click it, you'll be able to spot the object and delete it from there.
                </p>
                <p>
                  Installing OVR Metrics (highly recommended if you're a serious builder, we always use it running in
                  the background):
                  First you need to put your Meta Quest into developer mode. To do this:
                </p>
                <ul className="ml-3">
                  <li>Sign up as a developer at https://developer.oculus.com using the same email address that you
                    use with your Meta Quest, usually it's your Facebook email
                  </li>
                  <li>Next download OVR Metrics Tool at
                    https://developer.oculus.com/downloads/package/ovr-metrics-tool/ which will download a .zip file.
                    Open the .zip file and extract the .apk file, at this time it's OVRMetricsTool_v1.6.2.apk to your
                    Downloads folder
                  </li>
                  <li>Next install Sidequest from here https://sidequestvr.com/setup-howto</li>
                  <li>Connect your Meta Quest to your PC or Mac using the USB cable that comes with it. Sidequest should
                    detect your device. You will need to click Allow in your headset to "Allow USB debugging?"
                  </li>
                  <li>Run Sidequest, and click on the square icon in the top bar that has a down arrow in it and says
                    "Install APK from folder on computer". Navigate to where you unzipped the OVRMetricsTool_v1.6.2.apk
                    file and select and open it. It will be installed to your Meta Quest
                  </li>
                  <li>Run OVR Metrics by navigating in your headset to your App library and in the top right from the
                    dropdown change it from All to Unknown Sources, and select OVR Metrics Tool
                  </li>
                  <li>When you run OVR Metrics Tool the first time you need to select the toggle switch "Enable
                    Persistent Overlay" and you can also adjust the position and size of the overlay, and select
                    ADVANCED settings if you like
                  </li>
                  <li>Switch your App Library in your headset back to All to access and run your installed apps</li>
                  <li>The main setting to pay attention to is FPS (Frames Per Second), which if it goes below say 60
                    that means you have spawned too many models or ones with too many polygons or are too big
                  </li>
                  <li>We also recommend setting your device to 120Hz refresh rate so that you can find on your Meta Quest
                    by running Settings and choosing Experimental then toggle the slider to enable 120 Hz Refresh Rate
                  </li>
                </ul>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Accordion.Toggle as={Card.Header} eventKey="12">
              How does VRE - Virtual Real Estate - work on Villa?
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="12">
              <Card.Body>
                <p>
                  At the end of June 2022 Villa launched the in-app VRE (virtual real estate) game Galactica, a virtual
                  real estate terraforming platform where users can buy, develop, keep or sell to earn. How this works:
                </p>
                <ul className="ml-3">
                  <li className="pb-1">
                    When you launch Villa or in VR by pressing and holding the A or X button &gt; Menu &gt; Galactica,
                    you'll see the current planet where terraforming is offered. At the time of writing, it's the Red
                    Planet.
                  </li>
                  <li className="pb-1">
                    Land for sale is shown in green. Look to the top right panel for filtering by property types
                    (example: Visitable, for sale, owned, etc)
                  </li>
                  <li className="pb-1">
                    When you buy land, it's yours until you sell it
                  </li>
                  <li className="pb-1">
                    To build your land, you'll need to subscribe to platform services. Currently subscriptions start
                    at $9.99/mo with big savings on annual subscriptions.
                  </li>
                  <li className="pb-1">
                    If you stop subscribing you'll continue to have access to your land, you just won't be able to
                    build or modify it.
                  </li>
                  <li className="pb-1">
                    If you sell your parcel, ownership of the parcel and what's inside it will be transferred to the
                    buyer.
                  </li>
                  <li className="pb-1">
                    As you build your parcel, it's your responsibility to make sure the assets you build with have
                    the right license, especially if you plan to commercialize it. We make it very easy to find
                    objects in VR that have the right commercialization or modification licenses, such as CC BY. Be
                    sure to read further about this if you're using Sketchfab or other repos, and especially if you
                    buy or obtain something elsewhere on the internet. Villa is a user generated platform, and the
                    responsibility is passed on to creators to ensure that they're complying with assets according to
                    their respective licenses. Additionally when a creator creates objects and then sells them, the
                    creator relinquishes ownership in those items, who may be further sold to new buyers in
                    perpetuity.
                  </li>
                  <li className="pb-1">
                    Currently parcels are sold in game for a coin system purchasable with a credit card. In the
                    future we plan to additionally enable purchasing parcels as an NFT. We're not sure if there'll be
                    a way to convert a coin parcel into an NFT and vice versa, but it is a priority that we're looking
                    into. For now assume they're not interchangeable.
                  </li>
                  <li className="pb-1">
                    Currently you can buy and sell using coins, but you cannot cash out the coins for dollars. We
                    plan to enable a way to cash out coins in the future when Meta enables creators to do so, but
                    we're not sure how soon this will be available, and when it is we're not sure what platform fees
                    for this will be. For now, we do not take a commission on coins that a seller earns, simply
                    because for now this is a closed system. But this will change for cashing out.
                  </li>
                  <li className="pb-1">
                    NFT sales will inherently enable cashing out, which is part of the benefit.
                  </li>
                  <li className="pb-1">
                    We're not sure if parcels will be interoperable from Villa, but we're looking into that
                    technologically. For now, assume it's not.
                  </li>
                  <li className="pb-1">
                    Galactica Hexagons are 1KMˆ3 (that's 1 kilometer in diameter, cubed). Villas are 5KMˆ3, but are
                    not sellable (you get up to 10 with your subscription to platform services, and these act as
                    channels do in Discord)
                  </li>
                  <li className="pb-1">
                    If you're an NFT project and want to use NFTs as a subscription to your club (ie, only people
                    that have your NFTs may join your org) please get in touch with us at info@villa.rocks if you have
                    more than 10K NFT owners. We have this feature enabled, but it requires some manual work to turn
                    it on per org. We plan to add this feature as self-service in the near future.
                  </li>
                  <li className="pb-1">
                    You can make a parcel Visitable from Mod settings (press A &gt; Menu &gt; My Villas &gt; click on
                    your parcel and look to the left panel for the edit icon). At this time, the minimum objects
                    required
                    to make a parcel visitable is 5. Anything less than that and it's not visitable by the public. You
                    can keep it empty and give anyone in your org access, but you can't make it public. We don't want
                    to have a situation where people lose time coming to an empty parcel, or a boring parcel, so
                    please be sure to invest effort to make it worth people's visit, if that's what you want people to
                    do.
                  </li>
                  <li className="pb-1">
                    In addition to marking a parcel as Visitable, which can be easily found on Galactica by looking
                    for a yellow edge in the filter, you can also make a parcel or a Villa public, also from Mod
                    Settings. When you ask to make it public, a member of Villa willr review to ensure it looks legit.
                    You'll receive an email as part of that process, and when it gets approved your parcel or Villa
                    will be also accessible from the Public Access menu, either under Events or Exhibits. If you have
                    something to display choose Exhibit. If it's display + ongoing activity or one time activity,
                    choose Event and prepare to share with us the day/time of your event, why it's pertinent to the
                    public, and we'll see if/how we can help with promoting it to our users. Only DIY geos are
                    defaulted to when Visitable or published publicly.
                  </li>
                  <li className="pb-1">
                    When you buy a parcel, to change the skysphere or terrain of the DIY geo, do so from mod
                    settings. don't forget to set a Custom Spawn Location for your guests from there too.
                  </li>
                </ul>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Accordion.Toggle as={Card.Header} eventKey="13">
              How to use Zoom on Villa
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="13">
              <Card.Body>
                <p>
                  <h4>Connect your Zoom account to Villa</h4>
                </p>
                <p>
                  To create a new Zoom meeting in Villa you will need to connect your Zoom account to Villa.
                  There are two ways to this:
                  <ul className="ml-3">
                    <li>
                      Click the Hamburger button top right then <b>App Integrations</b> and click <b>Connect</b> button,
                      where you will be redirected to your Zoom account to approve adding Villa in the Zoom Marketplace.
                    </li>
                    <li>
                      Or browse to In the Zoom Marketplace either search for Villa by RealVR and click
                      the <b>Add</b> button, or you can
                      click here <a className="underline" target="_blank" rel="noopener"
                                    href="https://marketplace.zoom.us/apps/61GWKW7CQAmFH3X26usdbQ">Villa in Zoom
                      Marketplace</a> then
                      click the <b>Add</b> button.
                    </li>
                  </ul>
                </p>
                <p>
                  <h4>Using Zoom in Villa</h4>
                </p>
                <p>
                  In VR in Villa, press and hold the A button &gt; Spawn! &gt; and scroll on the left panel to Zoom,
                  select it, and look in the center panel.
                  From the 3 options choose the one that suits your needs:
                  <ul className="ml-3">
                    <li>
                      Create new Zoom meeting in VR: If you've added the Villa app in the Zoom Marketplace you can start
                      a new Zoom meeting by clicking the <b>1. Create new Zoom meeting in VR</b> button. To share the
                      Zoom URL with others you can to to https://app.villa.rocks, click the top right Hamburger
                      menu &gt; App Integrations and click the <b>Copy Zoom URL</b> button and then share that URL
                      with others to join you.
                    </li>
                    <li>
                      Join from VR to an existing Zoom meeting: You'll need to copy/paste a Zoom meeting URL by
                      clicking the top right Hamburger menu &gt; App Integrations and pasting the URL into the Zoom URL
                      field and click "Save Zoom URL". Then back in VR, click the <b>2. Join Existing Zoom meeting with
                      a URL</b> button and you'll join the Zoom meeting.
                    </li>
                    <li>
                      If you happen to know the Zoom meeting's ID and passcode, you can choose option number 3. and
                      enter those in VR and click the <b>Join Meeting</b> button
                    </li>
                  </ul>
                </p>
                <p>
                  <h4>Removing the Zoom app from Villa</h4>
                </p>
                <p>
                  <ul className="ml-3">
                    <li>
                      In a web browser login to your Zoom Account and navigate to the Zoom App Marketplace
                    </li>
                    <li>
                      Click <b>Manage</b> &gt; <b>Added Apps</b> or search for the Villa app
                    </li>
                    <li>
                      Click the Villa app
                    </li>
                    <li>
                      Click the <b>Remove</b> button
                    </li>
                  </ul>
                </p>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      </section>
    </>
  )
    ;
}

export default QuestionAnswer;
